import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { formatQuantityLabel } from "@swiggy-private/checkout-core";
import { TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { TextDivider } from "./quickCheckoutStyles";

const ITEM_LABEL = "Item";

type QuickCheckoutItemCountLabelProps = {
    totalItemCount: number;
};

function QuickCheckoutItemCountLabel({ totalItemCount }: QuickCheckoutItemCountLabelProps): React.ReactElement {
    return (
        <>
            <Text
                data-testid={TURBO_PAYMENT_METHOD_WIDGET_DATA_TEST_IDS.PAY_BUTTON_QUANTITY}
                variant="V2.body1.neutral.bold"
                color="text_Button_Primary"
                as="span"
            >
                {formatQuantityLabel(totalItemCount, ITEM_LABEL)}
            </Text>
            <TextDivider variant="V2.body1.neutral.regular" color="text_inverse_Med_Emphasis">
                {"|"}
            </TextDivider>
        </>
    );
}

export default memo(QuickCheckoutItemCountLabel);
